import React from "react";
import { Sparkle, CheckCircle } from "@phosphor-icons/react";

/**
 * "Clean load = lower price" trust block. Shown wherever the four
 * single-material categories (Concrete, Soil / Dirt, Brick, Metal) appear.
 */
export default function CleanLoadGuarantee({ testid = "clean-load-guarantee", className = "" }) {
  return (
    <div
      data-testid={testid}
      className={`border-2 border-emerald-600 bg-emerald-50 p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 bg-emerald-600 text-white flex items-center justify-center shrink-0">
          <Sparkle size={20} weight="fill" />
        </div>
        <div>
          <div className="text-[10px] font-extrabold tracking-[0.22em] uppercase text-emerald-700">
            Clean-load discount
          </div>
          <div className="font-display font-black text-xl sm:text-2xl text-slate-900 leading-tight">
            Keep it pure, pay less. Simple as that.
          </div>
        </div>
      </div>
      <p className="mt-3 text-sm sm:text-base text-slate-700 leading-relaxed">
        Keep your load to <span className="font-bold text-slate-900">concrete, brick, soil, or metal only</span>{" "}
        — and unlock discounted pricing, guaranteed. No mixing, no penalty pricing, no surprises.
        Clean load in, lower price out.
      </p>
      <ul className="mt-4 grid sm:grid-cols-2 gap-2">
        {[
          "Concrete only — up to 2 tons",
          "Brick only — up to 2 tons",
          "Soil / Dirt only — up to 1 ton",
          "Metal only — flat-rate scrap disposal",
        ].map((line) => (
          <li key={line} className="flex items-start gap-2 text-sm text-slate-800">
            <CheckCircle size={16} weight="fill" className="mt-0.5 shrink-0 text-emerald-600" />
            <span className="font-medium">{line}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
